!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("@driftt/tide-core"), require("react-dom"), require("@driftt/tide-icons"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core", "react-dom", "@driftt/tide-icons"], t);else {
    var n = "object" === typeof exports ? t(require("react"), require("@driftt/tide-core"), require("react-dom"), require("@driftt/tide-icons")) : t(e.react, e["@driftt/tide-core"], e["react-dom"], e["@driftt/tide-icons"]);
    for (var r in n) ("object" === typeof exports ? exports : e)[r] = n[r];
  }
}(window, function (e, t, n, r) {
  return function (e) {
    var t = {};
    function __webpack_require__(n) {
      if (t[n]) return t[n].exports;
      var r = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, __webpack_require__), r.l = !0, r.exports;
    }
    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) __webpack_require__.d(n, r, function (t) {
        return e[t];
      }.bind(null, r));
      return n;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 5);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    var r;
    !function () {
      "use strict";

      var n = {}.hasOwnProperty;
      function classNames() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];
          if (r) {
            var i = typeof r;
            if ("string" === i || "number" === i) e.push(r);else if (Array.isArray(r) && r.length) {
              var o = classNames.apply(null, r);
              o && e.push(o);
            } else if ("object" === i) for (var a in r) n.call(r, a) && r[a] && e.push(a);
          }
        }
        return e.join(" ");
      }
      e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (r = function () {
        return classNames;
      }.apply(t, [])) || (e.exports = r);
    }();
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(10);
  }, function (e, t, n) {
    var r = n(7);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(9)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(8)(!0)).push([e.i, ".tide-drawer {\n  background-color: var(--main-white);\n  display: flex;\n  left: 48px;\n  position: fixed;\n  transition: 0.2s;\n  transition-timing-function: ease-out;\n  width: calc(100% - 48px);\n  z-index: 1000;\n}\n\n.tide-drawer--bottom {\n  bottom: 0;\n  border-top: 2px solid var(--color-p1-10);\n  transform: translateY(158px);\n}\n\n.tide-drawer--top {\n  top: 0;\n  border-bottom: 2px solid var(--color-p1-10);\n  transform: translateY(-158px);\n}\n\n.tide-drawer--open {\n  transform: translateY(0px);\n  transition: 0.15s;\n  transition-timing-function: ease-out;\n}\n\n.tide-drawer--help-content {\n  border-image: linear-gradient(135deg, #ED1886, #8711FF) 100% 1;\n  border-top: 2px solid transparent;\n}\n\n.tide-div.tide-drawer--container {\n  align-items: center;\n  display: flex;\n  margin: 0 auto;\n  width: 800px;\n  padding: 40px 0;\n}\n\n.tide-text-span.tide-drawer--close {\n  cursor: pointer;\n  position: absolute;\n  right: 16px;\n  top: 18px;\n  z-index: 1;\n}\n\n.tide-text-span.tide-drawer--close svg path {\n  fill: var(--color-p1-8);\n}\n\n.tide-text-span.tide-drawer--close:hover svg path {\n  fill: var(--color-p1-10);\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,mCAAmC;EACnC,aAAa;EACb,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,MAAM;EACN,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,8DAA8D;EAC9D,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B",
      file: "style.css",
      sourcesContent: [".tide-drawer {\n  background-color: var(--main-white);\n  display: flex;\n  left: 48px;\n  position: fixed;\n  transition: 0.2s;\n  transition-timing-function: ease-out;\n  width: calc(100% - 48px);\n  z-index: 1000;\n}\n\n.tide-drawer--bottom {\n  bottom: 0;\n  border-top: 2px solid var(--color-p1-10);\n  transform: translateY(158px);\n}\n\n.tide-drawer--top {\n  top: 0;\n  border-bottom: 2px solid var(--color-p1-10);\n  transform: translateY(-158px);\n}\n\n.tide-drawer--open {\n  transform: translateY(0px);\n  transition: 0.15s;\n  transition-timing-function: ease-out;\n}\n\n.tide-drawer--help-content {\n  border-image: linear-gradient(135deg, #ED1886, #8711FF) 100% 1;\n  border-top: 2px solid transparent;\n}\n\n.tide-div.tide-drawer--container {\n  align-items: center;\n  display: flex;\n  margin: 0 auto;\n  width: 800px;\n  padding: 40px 0;\n}\n\n.tide-text-span.tide-drawer--close {\n  cursor: pointer;\n  position: absolute;\n  right: 16px;\n  top: 18px;\n  z-index: 1;\n}\n\n.tide-text-span.tide-drawer--close svg path {\n  fill: var(--color-p1-8);\n}\n\n.tide-text-span.tide-drawer--close:hover svg path {\n  fill: var(--color-p1-10);\n}\n"]
    }]);
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var n = function cssWithMappingToString(e, t) {
            var n = e[1] || "",
              r = e[3];
            if (!r) return n;
            if (t && "function" === typeof btoa) {
              var i = function toComment(e) {
                  return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
                }(r),
                o = r.sources.map(function (e) {
                  return "/*# sourceURL=" + r.sourceRoot + e + " */";
                });
              return [n].concat(o).concat([i]).join("\n");
            }
            return [n].join("\n");
          }(t, e);
          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" === typeof e && (e = [[null, e, ""]]);
        for (var r = {}, i = 0; i < this.length; i++) {
          var o = this[i][0];
          null != o && (r[o] = !0);
        }
        for (i = 0; i < e.length; i++) {
          var a = e[i];
          null != a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), t.push(a));
        }
      }, t;
    };
  }, function (e, t, n) {
    "use strict";

    var r = {},
      i = function isOldIE() {
        var e;
        return function memorize() {
          return "undefined" === typeof e && (e = Boolean(window && document && document.all && !window.atob)), e;
        };
      }(),
      o = function getTarget() {
        var e = {};
        return function memorize(t) {
          if ("undefined" === typeof e[t]) {
            var n = document.querySelector(t);
            if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
              n = n.contentDocument.head;
            } catch (r) {
              n = null;
            }
            e[t] = n;
          }
          return e[t];
        };
      }();
    function listToStyles(e, t) {
      for (var n = [], r = {}, i = 0; i < e.length; i++) {
        var o = e[i],
          a = t.base ? o[0] + t.base : o[0],
          s = {
            css: o[1],
            media: o[2],
            sourceMap: o[3]
          };
        r[a] ? r[a].parts.push(s) : n.push(r[a] = {
          id: a,
          parts: [s]
        });
      }
      return n;
    }
    function addStylesToDom(e, t) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n],
          o = r[i.id],
          a = 0;
        if (o) {
          for (o.refs++; a < o.parts.length; a++) o.parts[a](i.parts[a]);
          for (; a < i.parts.length; a++) o.parts.push(addStyle(i.parts[a], t));
        } else {
          for (var s = []; a < i.parts.length; a++) s.push(addStyle(i.parts[a], t));
          r[i.id] = {
            id: i.id,
            refs: 1,
            parts: s
          };
        }
      }
    }
    function insertStyleElement(e) {
      var t = document.createElement("style");
      if ("undefined" === typeof e.attributes.nonce) {
        var r = n.nc;
        r && (e.attributes.nonce = r);
      }
      if (Object.keys(e.attributes).forEach(function (n) {
        t.setAttribute(n, e.attributes[n]);
      }), "function" === typeof e.insert) e.insert(t);else {
        var i = o(e.insert || "head");
        if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        i.appendChild(t);
      }
      return t;
    }
    var a = function replaceText() {
      var e = [];
      return function replace(t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();
    function applyToSingletonTag(e, t, n, r) {
      var i = n ? "" : r.css;
      if (e.styleSheet) e.styleSheet.cssText = a(t, i);else {
        var o = document.createTextNode(i),
          s = e.childNodes;
        s[t] && e.removeChild(s[t]), s.length ? e.insertBefore(o, s[t]) : e.appendChild(o);
      }
    }
    var s = null,
      d = 0;
    function addStyle(e, t) {
      var n, r, i;
      if (t.singleton) {
        var o = d++;
        n = s || (s = insertStyleElement(t)), r = applyToSingletonTag.bind(null, n, o, !1), i = applyToSingletonTag.bind(null, n, o, !0);
      } else n = insertStyleElement(t), r = function applyToTag(e, t, n) {
        var r = n.css,
          i = n.media,
          o = n.sourceMap;
        if (i && e.setAttribute("media", i), o && btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleSheet) e.styleSheet.cssText = r;else {
          for (; e.firstChild;) e.removeChild(e.firstChild);
          e.appendChild(document.createTextNode(r));
        }
      }.bind(null, n, t), i = function remove() {
        !function removeStyleElement(e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(n);
      };
      return r(e), function updateStyle(t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else i();
      };
    }
    e.exports = function (e, t) {
      (t = t || {}).attributes = "object" === typeof t.attributes ? t.attributes : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = i());
      var n = listToStyles(e, t);
      return addStylesToDom(n, t), function update(e) {
        for (var i = [], o = 0; o < n.length; o++) {
          var a = n[o],
            s = r[a.id];
          s && (s.refs--, i.push(s));
        }
        e && addStylesToDom(listToStyles(e, t), t);
        for (var d = 0; d < i.length; d++) {
          var l = i[d];
          if (0 === l.refs) {
            for (var c = 0; c < l.parts.length; c++) l.parts[c]();
            delete r[l.id];
          }
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(0),
      i = n.n(r),
      o = n(3),
      a = n.n(o),
      s = n(2),
      d = n.n(s),
      l = n(1),
      c = n(4);
    n(6);
    var p = class Drawer_BottomDrawer extends r.Component {
      constructor(e) {
        super(e), this.delayRemove = () => {
          setTimeout(() => {
            this.setState(() => ({
              shouldHide: !0
            }), this.toggleWidget);
          }, 300);
        }, this.delayShow = () => {
          setTimeout(() => {
            this.setState(() => ({
              isOpen: !0
            }), this.toggleWidget);
          }, 100);
        }, this.toggleWidget = () => {
          const e = this.props,
            t = e.isOpen;
          e.toggleWidget && (t ? window.drift && window.drift.hide() : window.drift && window.drift.show());
        }, this.state = {
          isOpen: e.isOpen,
          shouldHide: !e.isOpen
        };
      }
      componentDidMount() {
        this.toggleWidget();
      }
      componentDidUpdate(e) {
        e.isOpen !== this.props.isOpen && (this.props.isOpen ? this.setState(() => ({
          shouldHide: !1
        }), this.delayShow) : this.setState(() => ({
          isOpen: !1
        }), this.delayRemove));
      }
      render() {
        const e = this.state,
          t = e.isOpen,
          n = e.shouldHide,
          r = this.props,
          o = r.anchor,
          s = void 0 === o ? "bottom" : o,
          p = r.children,
          u = r.className,
          f = r.closeDrawer,
          A = r.containerClassName,
          m = r.isHelpContent;
        if (n) return null;
        const h = i.a.createElement(l.Div, {
          className: d()("tide-drawer tide-drawer--".concat(s), {
            [u]: u,
            "tide-drawer--help-content": m,
            "tide-drawer--open": t
          })
        }, i.a.createElement(l.Span, {
          className: "tide-drawer--close",
          onClick: f
        }, i.a.createElement(c.Icon, {
          name: "close",
          width: 16
        })), i.a.createElement(l.Div, {
          className: d()("tide-drawer--container", {
            [A]: A
          })
        }, p));
        return a.a.createPortal(h, document.getElementById("root"));
      }
    };
    n.d(t, "Drawer", function () {
      return p;
    });
  }]);
});